import { currentUser } from './stores.js';
import { get } from 'svelte/store';

const sb_auth_url = () => {
	return [true, 'true'].includes(process['env'].PROD_ENV)
		? 'https://auth.shopbox.ai'
		: 'https://beta-sb-auth-vlwut6qbsq-ew.a.run.app';
};

export const fetchUsers = async () => {
	const res = await fetch(sb_auth_url() + `/api/v2/clients/${get(currentUser).clientId}/users`, {
		headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
	});
	return await res.json();
};

export const fetchCurrentUser = async () => {
	const res = await fetch(
		sb_auth_url() + `/api/v2/users/me?tokens=true&cid=${get(currentUser).clientId}`,
		{
			headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
		}
	);
	return await res.json();
};

export const updateUserPermissions = async (permissions, user_id) => {
	let params = [];
	for (const permission in permissions) {
		params.push(`${permission}=${permissions[permission]}`);
	}
	let formatedParams = params.join('&');

	const res = await fetch(
		sb_auth_url() +
			`/api/v2/clients/${get(currentUser).clientId}/users/${user_id}?${formatedParams}`,
		{
			method: 'PATCH',
			headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
		}
	);
	return res.ok && res.status == 202;
};

export const deleteUser = async (user_id) => {
	const res = await fetch(
		sb_auth_url() + `/api/v1/users/${user_id}?cid=${get(currentUser).clientId}`,
		{
			method: 'DELETE',
			headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
		}
	);
	return res.ok && res.status == 204;
};

export const inviteNewUser = async (email) => {
	const res = await fetch(
		sb_auth_url() + `/api/v2/clients/${get(currentUser).clientId}/users/invite`,
		{
			method: 'POST',
			body: JSON.stringify(email),
			headers: {
				Authorization: `Bearer ${get(currentUser).accessToken}`,
				'Content-Type': 'application/json'
			}
		}
	);

	return await res.json();
};
